import { LinkCreateForm } from '../../links/LinkCreateForm';
import type { CreateBodyProps } from './createBodyProps';
import { destinationParent } from '../destination/createDestination';

/** New link, in the chosen collection or at the workspace root. It stays put. */
export function LinkBody({
  destination,
  surface,
  onDone,
  onDestinationProblem,
  onBusyChange,
}: CreateBodyProps) {
  return (
    <LinkCreateForm
      parent={destinationParent(destination)}
      surface={surface}
      onCreated={onDone}
      onDestinationProblem={onDestinationProblem}
      onBusyChange={onBusyChange}
    />
  );
}
